// extracted by mini-css-extract-plugin
export default {"white":"#fff","whiteD":"#e2e2e2","grayL":"#d3d3d3","gray":"gray","grayD":"#474747","blackL":"#181818","black":"#000","blue":"#15c"};